import Modal from "../General/Modal"
import Input from "../General/Input"
import Button from "../General/Button"
import { useDispatch, useSelector } from "react-redux"
import Select from "../General/Select"
import { enquiryFormWithoutLoginSchema } from "../../validations/Enquiry"
import { useFormik } from "formik"
import { submitEnquiry, closeEnquiryModal } from "../../store/CoreSlice"
import { useEffect } from "react"
import format from "date-fns/format"

function EnquiryForm(props : any) {		

	let initialValues : {[k: string]: any} = {
		created_by_name : '',
		created_by_phone : '',
		created_by_email : '',
		created_by_company_name : '',
		dial_code : {
			label : '+91',
			value : '+91'
		}
	}

	const dispatch : any = useDispatch();
	const {enquiryState} = useSelector((state : any) => state.core)
	const { values, errors, handleSubmit, handleBlur, handleChange, touched, resetForm, setFieldValue } = useFormik({
		initialValues: initialValues,
		validationSchema: enquiryFormWithoutLoginSchema,

		onSubmit : (values, action) => {
			const payload = {...values, ...props.data}			
			payload['created_by_phone'] = `${payload.dial_code.value}-${payload['created_by_phone']}`;
			dispatch(submitEnquiry(payload));
		}
	});

	useEffect(() => {
		if (enquiryState.showSuccessModal) {
			props.onClose();
			resetForm();
		}
	}, [enquiryState.showSuccessModal])
	
	return (
		<div>
			<Modal show={props.show} styles='w-4/5 lg:w-1/3'>
				<div className="pt-5 pb-14 max-h-[90vh] overflow-y-auto px-5 lg:px-10">
					<div className="close flex justify-between">
						<h2 className="text-theme-black text-xl"> {props.data.product && props.data.product_string} </h2>
						<svg onClick = {props.onClose} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer">
							<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
						</svg>
					</div>

					<div className="py-5 lg:grid grid-cols-2">
						{
							props.data.expected_certificates && props.data.expected_certificates.length !== 0 && 
							<p className="text-sm text-theme-black lg:text-[13px]">
								<span className="opacity-70">Certificates : </span>
								{
									props.data.expected_certificates.map((certificate : any, index : number) => (
										<span key={index}>
											{certificate.name} 
											{
												index !== props.data.expected_certificates.length - 1 &&
												<span> / </span>
											}
										</span>
									))
								}
							</p>
						}
						{
							props.data.country_string && 
							<p className="text-sm text-theme-black lg:text-[13px]"> <span className="opacity-70">Delivery Country</span> : <span> {props.data.country_string} </span> </p>
						}
						<p className="text-sm text-error lg:text-[13px]"> <span className="opacity-70 text-theme-black">QTY : </span> {props.data.quantity} KG </p>

						{
							props.data.expected_date &&
							<p className="text-sm text-theme-black lg:text-[13px]"> <span className="opacity-70"> Delivery Date </span> : <span> {props.data.expected_date && format(props.data.expected_date, "dd/MM/yyyy")} </span> </p>
						}
					</div>

					<hr className="pb-5"/>

					<div className="">
						<form onSubmit={handleSubmit}>
							{
	
								<div>
									<Input
										label='Name'
										labelColor='#444444'
										labelProperties='opacity-50'
										properties='border border-slate-300 rounded h-11 placeholder:text-sm'
										placeholder = "Enter Name"
										name='created_by_name'
										value={values.created_by_name}
										onBlur={handleBlur}
										onChange={handleChange}
										error={errors.created_by_name}
										touched={touched.created_by_name}
									/>
								</div>
							}

							{
								<div className="pt-4">
									<Input
										label='Email'
										labelColor='#444444'
										labelProperties='opacity-50'
										properties='border border-slate-300 rounded h-11 placeholder:text-sm'
										placeholder = "Enter Email"
										name='created_by_email'
										value={values.created_by_email}
										onBlur={handleBlur}
										onChange={handleChange}
										error={errors.created_by_email}
										touched={touched.created_by_email}
									/>
								</div>
							}

							<div className="pt-4">
								<label className='inline-block mb-1 text-theme-black opacity-50'> Phone </label>
								<div className="flex justify-start items-start">
									<div style={{ width : '25%' }}>
										<Select 
											search
											suffix = {
												<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
													<path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
												</svg>
											}
											defaultValue = {
												{
													label : '+91',
													value : '+91'
												}
											}
											value = {values.dial_code}
											onChange = {(selected : any) => setFieldValue('dial_code', selected)}
											placeholder = '+XX'
											items = {props.countryList}
											additionalStyles = {{
												padding : '2.4px 3px',
											}}
											selectedColor = 'gray'
											placeholderStyles = {{
												fontSize : 13,
												fontWeight : 300
											}}
										/>
									</div>
									<div style={{ width : '75%' }}>
										<Input
											type='text'
											labelColor='#444444'
											labelProperties='opacity-50'
											properties='border border-slate-300 rounded h-11 placeholder:text-sm'
											outerProperties = 'pl-3'
											placeholder = "Enter Phone"
											name='created_by_phone'
											value={values.created_by_phone}
											onBlur={handleBlur}
											onChange={handleChange}
											error={errors.created_by_phone}
											touched={touched.created_by_phone}
											maxLength={10}
										/>
									</div>
								</div>
							</div>

							<div className="pt-4">
								<Input
									label='Company Name'
									labelColor='#444444'
									labelProperties='opacity-50'
									onChange={handleChange}
									properties='border border-slate-300 rounded h-11 placeholder:text-sm'
									placeholder = "Enter Company Name"
									name='created_by_company_name'
									value={values.created_by_company_name}
									onBlur={handleBlur}
									error={errors.created_by_company_name}
									touched={touched.created_by_company_name}
								/>
							</div>

							<Button
								type="submit"
								styles='bg-theme-orange text-white w-full mt-8 h-12'
							>
								Submit
							</Button>
						</form>

					</div>
				</div>
			</Modal>
		</div>
	)
}

export default EnquiryForm